import { combineReducers } from 'redux';
import user from 'features/user/redux/reducer';
import auth from 'features/auth/redux/reducer';
import dashboard from 'features/dashboard/redux/reducer';
import message from 'features/message/redux/reducer';
import giftCards from 'features/my-gift-cards/redux/reducer';
import subscriptionReducer from 'features/subscription/redux/reducer'

export default combineReducers({
  auth,
  user,
  dashboard,
  message,
  giftCards,
  subscriptionReducer
});
